import { call, put, takeEvery } from 'redux-saga/effects';
import { setCustomerName } from '../../requests/set_customer_name_request';
import { SET_CUSTOMER_NAME_REQUEST } from '../constants/customer_name.constants';
import { setCustomerNameFailure, setCustomerNameSuccess } from '../actions/set_customer_name.actions';

function* setCustomerNameRequest({ _id, customer_name }) {
    const { result, error } = yield call(setCustomerName, _id, customer_name);
    if (result) {
        yield put(setCustomerNameSuccess(_id, customer_name));
    } else {
        yield put(setCustomerNameFailure(error));
    }
}

export default function* setCustomerNameSaga() {
    yield takeEvery(SET_CUSTOMER_NAME_REQUEST, setCustomerNameRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/customer_name.saga.js